import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=daf09478&scoped=true&"
import script from "./SalesOrder.vue?vue&type=script&lang=js&"
export * from "./SalesOrder.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrder.vue?vue&type=style&index=0&id=daf09478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf09478",
  null
  
)

export default component.exports